module.exports = __webpack_public_path__ + "img/GP1.237ce0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/GP1.png
// module id = /Wnw
// module chunks = 1